export const AboutHeroText = {
  en: {
    preTitle: "About",
    name: "Maria Pooley",
    subtitle: "Business Coach • Advisor • Founder of Maria Advisory",
    shortIntro:
      "Helping business owners grow with clarity, structure, and measurable results.",
  },

  vi: {
    preTitle: "Giới thiệu",
    name: "Maria Pooley",
    subtitle:
      "Chuyên gia huấn luyện kinh doanh • Cố vấn • Nhà sáng lập Maria Advisory",
    shortIntro:
      "Đồng hành cùng doanh nghiệp phát triển với chiến lược rõ ràng, cấu trúc và hiệu quả đo lường được.",
  },
};

export const quoteAboutText = {
  en: {
    title: "Grow Profitably. Lead with Clarity. Achieve Measurable Results.",
    body: "",
  },

  vi: {
    title:
      "Tăng trưởng bền vững. Lãnh đạo rõ định hướng. Đạt kết quả đo lường được.",
    body: "",
  },
};

export const missionAboutText = {
  en: {
    title: "Successful Business Strategy & Growth",
    description:
      "For business owners who want to boost sales, restructure, re-energize, and create a clear plan for sustainable growth.",
  },

  vi: {
    title: "Chiến lược & Tăng trưởng Doanh nghiệp Bền vững",
    description:
      "Dành cho các chủ doanh nghiệp muốn tăng doanh thu, tái cấu trúc, làm mới năng lượng và xây dựng kế hoạch rõ ràng cho tăng trưởng bền vững.",
  },
};

export const aboutMariaText = {
  en: {
    title: "About Maria Pooley",

    intro: [
      "Maria Pooley is a business advisor, coach, and operations specialist with over 20 years of international experience across export/import, real estate, and business operations.",
      "Having worked across Vietnam, Thailand, Myanmar, Cambodia, Malaysia, China, Australia, and New Zealand, Maria brings a deep understanding of different markets, cultures, and business environments.",
      "Through Maria Advisory, she helps business owners and leadership teams identify challenges, improve operations, strengthen leadership, and create practical strategies for sustainable growth.",
      "Through Maria Advisory, she helps business owners and leadership teams identify challenges, improve operations, strengthen leadership, and create practical strategies for sustainable growth.",
    ],

    highlight:
      "Grow Profitably. Lead with Clarity. Achieve Measurable Results.",

    body: [],

    closingTitle: "",
    closingText: "",

    cta: "",
  },

  vi: {
    title: "Về Maria Pooley & Maria Advisory",

    intro: [
      "Maria Pooley là một chuyên gia huấn luyện kinh doanh, cố vấn chiến lược và chuyên gia vận hành giàu kinh nghiệm, đồng thời là nhà sáng lập Maria Advisory. Cô đồng hành cùng các chủ doanh nghiệp, lãnh đạo và tổ chức để thúc đẩy tăng trưởng với sự rõ ràng, cấu trúc và hiệu quả đầu tư đo lường được.",
      "Với hơn 20 năm kinh nghiệm quốc tế trong lĩnh vực xuất nhập khẩu, bất động sản và vận hành doanh nghiệp, Maria mang đến góc nhìn thực tiễn sâu sắc về lãnh đạo, tối ưu vận hành và cải thiện hiệu suất.",
      "Cô đã làm việc tại Việt Nam, Thái Lan, Myanmar, Campuchia, Malaysia, Trung Quốc, Úc và New Zealand, giúp cô hiểu rõ sự đa dạng về thị trường, văn hoá và hệ thống kinh doanh.",
      "Trong môi trường kinh doanh nhanh và cạnh tranh ngày nay, nhiều doanh nghiệp đầu tư mạnh vào bán hàng, marketing và vận hành nhưng không thực sự biết điều gì tạo ra kết quả. Maria Advisory giúp doanh nghiệp vượt qua suy đoán bằng cách xây dựng chiến lược tăng trưởng có cấu trúc, hệ thống theo dõi hiệu suất và tư duy ra quyết định dựa trên ROI.",
    ],

    highlight:
      "Tại Maria Advisory, tăng trưởng không dựa vào may mắn — mà được đo lường, quản lý và tạo ra kết quả.",

    body: [
      "Maria làm việc trực tiếp với chủ doanh nghiệp và đội ngũ lãnh đạo thông qua quy trình huấn luyện và đào tạo có cấu trúc, giúp xác định vấn đề cốt lõi, loại bỏ điểm nghẽn vận hành và mở ra mức độ năng suất và lợi nhuận cao hơn.",
      "Cô hỗ trợ doanh nghiệp xây dựng chiến lược tăng trưởng thực tế, triển khai hệ thống KPI và báo cáo, đồng thời cải thiện hiệu quả kinh doanh trong bán hàng, marketing và vận hành.",
      "Nếu bạn sẵn sàng tăng trưởng bền vững thông qua chiến lược rõ ràng, thực thi kỷ luật và quyết định dựa trên ROI, Maria Pooley và đội ngũ sẽ mang đến chuyên môn, cấu trúc và sự đồng hành để đưa doanh nghiệp của bạn lên một tầm cao mới.",
    ],

    closingTitle:
      "Tăng trưởng bền vững. Lãnh đạo rõ ràng. Đạt kết quả đo lường được.",
    closingText:
      "Maria Pooley giúp chủ doanh nghiệp và lãnh đạo khai phá tăng trưởng, loại bỏ điểm nghẽn và tối đa hóa ROI thông qua chiến lược thực tiễn, huấn luyện có cấu trúc và giải pháp dựa trên hiệu suất.",

    cta: "Chuyển đổi doanh nghiệp của bạn ngay hôm nay — tham gia cùng Maria và bắt đầu đạt được mục tiêu và ước mơ của bạn.",
  },
};

export const ourApproachMaria = {
  en: {
    smallTitle: "How We Work",
    title: "Our Approach",

    description:
      "At Maria Advisory, we believe successful business growth starts with understanding your unique challenges, goals, and opportunities. Our approach combines strategic thinking with practical implementation to help businesses create meaningful and measurable improvements.",

    steps: [
      {
        number: "01",
        title: "Understand Your Business Challenges",
        description:
          "We take the time to understand your current situation, challenges, goals, and priorities to identify what is truly impacting your business performance.",
      },
      {
        number: "02",
        title: "Identify Opportunities for Growth",
        description:
          "Through business assessment and strategic discussions, we uncover opportunities to improve performance, strengthen operations, and unlock growth potential.",
      },
      {
        number: "03",
        title: "Develop Practical Strategies",
        description:
          "We create tailored strategies and action plans designed around your business needs, focusing on productivity, profitability, leadership, and sustainable growth.",
      },
      {
        number: "04",
        title: "Support Implementation",
        description:
          "We work alongside business owners and teams to turn strategies into action, providing guidance, accountability, and practical support throughout the process.",
      },
      {
        number: "05",
        title: "Measure Progress and Results",
        description:
          "We track progress, review outcomes, and refine strategies to ensure your business continues moving towards its goals.",
      },
    ],

    closing:
      "Our approach is helping businesses achieve clearer direction, stronger performance, and sustainable success.",
  },

  vi: {
    smallTitle: "Cách Chúng Tôi Đồng Hành",
    title: "Phương Pháp Tiếp Cận",

    description:
      "Tại Maria Advisory, chúng tôi tin rằng sự phát triển bền vững của doanh nghiệp bắt đầu từ việc thấu hiểu những thách thức, mục tiêu và cơ hội riêng của từng doanh nghiệp. Phương pháp của chúng tôi kết hợp giữa tư duy chiến lược và triển khai thực tiễn để tạo ra những cải thiện rõ ràng và có thể đo lường.",

    steps: [
      {
        number: "01",
        title: "Thấu Hiểu Thách Thức Doanh Nghiệp",
        description:
          "Chúng tôi dành thời gian tìm hiểu tình hình hiện tại, những khó khăn, mục tiêu và ưu tiên của doanh nghiệp để xác định các yếu tố thực sự ảnh hưởng đến hiệu quả hoạt động.",
      },
      {
        number: "02",
        title: "Xác Định Cơ Hội Tăng Trưởng",
        description:
          "Thông qua đánh giá doanh nghiệp và các buổi tư vấn chiến lược, chúng tôi giúp phát hiện những cơ hội để nâng cao hiệu suất, tối ưu vận hành và mở rộng tiềm năng tăng trưởng.",
      },
      {
        number: "03",
        title: "Xây Dựng Chiến Lược Thực Tiễn",
        description:
          "Chúng tôi xây dựng chiến lược và kế hoạch hành động phù hợp với từng doanh nghiệp, tập trung vào năng suất, lợi nhuận, năng lực lãnh đạo và tăng trưởng bền vững.",
      },
      {
        number: "04",
        title: "Đồng Hành Triển Khai",
        description:
          "Chúng tôi làm việc cùng chủ doanh nghiệp và đội ngũ để biến chiến lược thành hành động, đồng thời cung cấp sự hướng dẫn, trách nhiệm và hỗ trợ thực tế trong suốt quá trình thực hiện.",
      },
      {
        number: "05",
        title: "Đo Lường Tiến Độ & Kết Quả",
        description:
          "Chúng tôi theo dõi tiến độ, đánh giá kết quả và liên tục điều chỉnh chiến lược để đảm bảo doanh nghiệp luôn tiến gần hơn đến mục tiêu đã đề ra.",
      },
    ],

    closing:
      "Phương pháp của chúng tôi đã giúp nhiều doanh nghiệp có định hướng rõ ràng hơn, nâng cao hiệu quả hoạt động và đạt được thành công bền vững.",
  },
};

export const TeamText = {
  en: {
    title: "Our Team & Expertise",
    secondTitle: "Success Stories",

    intro: [
      "Behind Maria Advisory is a trusted team of experienced professionals, coaches, and specialists who work together to support businesses with practical solutions, strategic guidance, and growth opportunities.",
      "Led by Maria Pooley, our team brings together diverse expertise across business advisory, coaching, leadership development, operations, marketing, technology, and business networks. This allows us to provide tailored support that addresses the unique needs, challenges, and goals of each business.",
      "We believe successful business growth requires more than one area of expertise. By combining different skills, perspectives, and industry knowledge, we help businesses develop stronger strategies, improve performance, and access the right resources to achieve sustainable growth.",
      "We believe successful business growth requires more than one area of expertise. By combining different skills, perspectives, and industry knowledge, we help businesses develop stronger strategies, improve performance, and access the right resources to achieve sustainable growth.",
    ],
  },

  vi: {
    title: "Đội Ngũ & Chuyên Môn",
    secondTitle: "Đồng Hành Cùng Thành Công",

    intro: [
      "Đằng sau Maria Advisory là đội ngũ gồm các chuyên gia, huấn luyện viên và cố vấn giàu kinh nghiệm, cùng phối hợp để hỗ trợ doanh nghiệp bằng những giải pháp thực tiễn, định hướng chiến lược và cơ hội phát triển.",

      "Dưới sự dẫn dắt của Maria Pooley, đội ngũ của chúng tôi quy tụ chuyên môn đa dạng trong tư vấn doanh nghiệp, huấn luyện, phát triển năng lực lãnh đạo, vận hành, marketing, công nghệ và kết nối mạng lưới kinh doanh. Điều này giúp chúng tôi mang đến các giải pháp phù hợp với nhu cầu, thách thức và mục tiêu riêng của từng doanh nghiệp.",

      "Chúng tôi tin rằng sự phát triển bền vững của doanh nghiệp đòi hỏi nhiều hơn một lĩnh vực chuyên môn. Bằng cách kết hợp kinh nghiệm, góc nhìn đa chiều và kiến thức thực tiễn từ nhiều ngành nghề, chúng tôi giúp doanh nghiệp xây dựng chiến lược hiệu quả hơn, nâng cao năng lực vận hành và tiếp cận các nguồn lực phù hợp để phát triển lâu dài.",
    ],
  },
};

export const WhoWeHelpText = {
  en: {
    title: "Who We Help",
    secondTitle: "Supporting Businesses at Every Stage",

    intro: [
      "We work with business owners, SMEs, entrepreneurs, managers, and professionals across a wide range of industries who are looking to improve performance, strengthen leadership, and achieve sustainable growth.",

      "Every business journey is unique. We provide practical guidance while maintaining the highest standards of professionalism, trust, and confidentiality.",
    ],

    highlight: "Our clients include:",

    clients: [
      {
        title: "SMEs and Growing Businesses",
        description:
          "Supporting established and growing businesses to improve performance, strengthen operations, and achieve sustainable growth.",
        color: "#A52126", // Burgundy
      },
      {
        title: "Business Owners & Entrepreneurs",
        description:
          "Helping founders make confident decisions, overcome challenges, and build stronger businesses.",
        color: "#1E3A8A", // Royal Blue
      },
      {
        title: "Directors & Managers",
        description:
          "Developing leadership capability, strategic thinking, and effective team management.",
        color: "#0F766E", // Teal
      },
      {
        title: "Start-ups & Scale-ups",
        description:
          "Providing practical guidance from business planning through to growth and expansion.",
        color: "#7C3AED", // Purple
      },
      {
        title: "Professional Service Firms",
        description:
          "Supporting accountants, consultants, legal firms, and other professional practices with strategic business advice.",
        color: "#EA580C", // Orange
      },
      {
        title: "Import & Export Businesses",
        description:
          "Helping businesses strengthen operations, partnerships, and international growth opportunities.",
        color: "#15803D", // Green
      },
      {
        title: "Investors & Property Professionals",
        description:
          "Providing strategic advice, business insight, and valuable industry connections.",
        color: "#B45309", // Gold
      },
    ],
  },

  vi: {
    title: "Chúng Tôi Hỗ Trợ Ai",
    secondTitle: "Đồng Hành Cùng Doanh Nghiệp Ở Mọi Giai Đoạn",

    intro: [
      "Chúng tôi đồng hành cùng các chủ doanh nghiệp, doanh nghiệp vừa và nhỏ (SMEs), doanh nhân, nhà quản lý và các chuyên gia thuộc nhiều lĩnh vực đang mong muốn nâng cao hiệu quả hoạt động, phát triển năng lực lãnh đạo và đạt được tăng trưởng bền vững.",

      "Mỗi doanh nghiệp đều có một hành trình riêng. Chúng tôi mang đến những giải pháp thực tiễn, phù hợp với từng doanh nghiệp, đồng thời luôn đề cao sự chuyên nghiệp, uy tín và tính bảo mật trong mọi hoạt động tư vấn.",
    ],

    highlight: "Khách hàng của chúng tôi bao gồm:",

    clients: [
      {
        title: "Doanh Nghiệp Vừa Và Nhỏ (SMEs) & Doanh Nghiệp Đang Phát Triển",
        description:
          "Hỗ trợ các doanh nghiệp đã hoạt động và đang tăng trưởng nâng cao hiệu quả kinh doanh, tối ưu vận hành và phát triển bền vững.",
        color: "#A52126",
      },
      {
        title: "Chủ Doanh Nghiệp & Doanh Nhân",
        description:
          "Đồng hành cùng các nhà sáng lập đưa ra quyết định tự tin, vượt qua thách thức và xây dựng doanh nghiệp vững mạnh.",
        color: "#1E3A8A",
      },
      {
        title: "Giám Đốc & Nhà Quản Lý",
        description:
          "Phát triển năng lực lãnh đạo, tư duy chiến lược và kỹ năng quản lý đội ngũ hiệu quả.",
        color: "#0F766E",
      },
      {
        title: "Doanh Nghiệp Khởi Nghiệp & Mở Rộng Quy Mô",
        description:
          "Cung cấp hướng dẫn thực tiễn từ giai đoạn lập kế hoạch kinh doanh đến tăng trưởng và mở rộng.",
        color: "#7C3AED",
      },
      {
        title: "Các Công Ty Dịch Vụ Chuyên Nghiệp",
        description:
          "Hỗ trợ các công ty kế toán, tư vấn, luật và các đơn vị dịch vụ chuyên nghiệp khác bằng những giải pháp tư vấn chiến lược.",
        color: "#EA580C",
      },
      {
        title: "Doanh Nghiệp Xuất Nhập Khẩu",
        description:
          "Giúp doanh nghiệp nâng cao hiệu quả vận hành, xây dựng quan hệ đối tác và mở rộng cơ hội phát triển quốc tế.",
        color: "#15803D",
      },
      {
        title: "Nhà Đầu Tư & Chuyên Gia Bất Động Sản",
        description:
          "Cung cấp tư vấn chiến lược, góc nhìn kinh doanh và kết nối với mạng lưới đối tác giá trị.",
        color: "#B45309",
      },
    ],
  },
};

export const WhyChooseUsText = {
  en: {
    title: "Why Choose Us",
    secondTitle: "Your Trusted Business Growth Partner",

    intro: [
      "At Maria Advisory, we combine practical business experience, strategic thinking, and personalised support to help businesses grow with confidence and achieve sustainable success.",
    ],

    reasons: [
      {
        title: "Practical Business Experience",
        description:
          "With over 20 years of international business experience across multiple industries and markets, we bring real-world knowledge and practical solutions—not just theory.",
      },
      {
        title: "Strategic & Results-Focused Approach",
        description:
          "We help businesses move from challenges to clear strategies by identifying opportunities, improving performance, and creating practical plans for sustainable growth.",
      },
      {
        title: "Personalised Support",
        description:
          "Every business is unique. We take the time to understand your goals, challenges, and priorities to provide tailored guidance that fits your specific needs.",
      },
      {
        title: "International Business Perspective",
        description:
          "Our experience across New Zealand, Australia, and Asian markets provides valuable insights into different business environments, cultures, and growth opportunities.",
      },
      {
        title: "Strong Network & Connections",
        description:
          "Through the BDI Business Network and strategic partnerships, we connect businesses with valuable relationships, resources, and opportunities for collaboration.",
      },
      {
        title: "Commitment to Long-Term Success",
        description:
          "We work alongside business owners and leaders to build stronger businesses through continuous improvement, effective systems, and confident decision-making.",
      },
    ],

    closing:
      "At Maria Advisory, we don't just provide advice—we partner with you to create meaningful progress and sustainable business success.",
  },

  vi: {
    title: "Vì Sao Chọn Chúng Tôi",
    secondTitle: "Đối Tác Đồng Hành Phát Triển Doanh Nghiệp",

    intro: [
      "Tại Maria Advisory, chúng tôi kết hợp kinh nghiệm thực tiễn, tư duy chiến lược và sự đồng hành tận tâm để giúp doanh nghiệp phát triển bền vững và tự tin hướng đến thành công lâu dài.",
    ],

    reasons: [
      {
        title: "Kinh Nghiệm Thực Tiễn",
        description:
          "Với hơn 20 năm kinh nghiệm kinh doanh quốc tế trên nhiều lĩnh vực và thị trường, chúng tôi mang đến những giải pháp thực tế và hiệu quả, không chỉ là lý thuyết.",
      },
      {
        title: "Chiến Lược Hướng Đến Kết Quả",
        description:
          "Chúng tôi giúp doanh nghiệp chuyển từ thách thức thành chiến lược rõ ràng bằng cách xác định cơ hội, nâng cao hiệu quả hoạt động và xây dựng kế hoạch phát triển bền vững.",
      },
      {
        title: "Đồng Hành Theo Nhu Cầu Riêng",
        description:
          "Mỗi doanh nghiệp đều khác biệt. Chúng tôi dành thời gian tìm hiểu mục tiêu, thách thức và ưu tiên của bạn để đưa ra giải pháp phù hợp nhất.",
      },
      {
        title: "Góc Nhìn Kinh Doanh Quốc Tế",
        description:
          "Kinh nghiệm tại New Zealand, Australia và các thị trường châu Á giúp chúng tôi mang đến góc nhìn đa chiều về môi trường kinh doanh, văn hóa và cơ hội phát triển.",
      },
      {
        title: "Mạng Lưới Kết Nối Mạnh Mẽ",
        description:
          "Thông qua BDI Business Network và các đối tác chiến lược, chúng tôi kết nối doanh nghiệp với những mối quan hệ, nguồn lực và cơ hội hợp tác giá trị.",
      },
      {
        title: "Cam Kết Thành Công Dài Hạn",
        description:
          "Chúng tôi đồng hành cùng chủ doanh nghiệp và đội ngũ lãnh đạo để xây dựng doanh nghiệp vững mạnh thông qua cải tiến liên tục, hệ thống hiệu quả và quyết định kinh doanh tự tin.",
      },
    ],

    closing:
      "Tại Maria Advisory, chúng tôi không chỉ đưa ra lời khuyên mà còn đồng hành cùng bạn để tạo nên những bước tiến ý nghĩa và thành công bền vững.",
  },
};

export const aboutButtons = {
  en: {
    book: "Book Consultation",
  },
  vi: {
    book: "Đặt lịch tư vấn",
  },
};

export const discussMariaAbout = {
  en: {
    quote:
      "Start growing your business today. Book a Complimentary Business Health Check to explore your business potential and unlock new growth opportunities.",

    name: "Maria Pooley",

    role: "Founder | Business Advisor | Consultant | Leadership Coach",

    button1: "Enquire Now",
  },

  vi: {
    quote:
      "Bắt đầu phát triển doanh nghiệp của bạn ngay hôm nay. Đặt lịch Kiểm Tra Doanh Nghiệp Miễn Phí để khám phá tiềm năng kinh doanh và mở ra những cơ hội tăng trưởng mới.",

    name: "Maria Pooley",

    role: "Nhà Sáng Lập | Cố Vấn Kinh Doanh | Chuyên Gia Tư Vấn | Coaching Lãnh Đạo",

    button1: "Liên hệ ngay",
  },
};
